import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import uiReducer from "./reducers/ui";
import dbReducer from "./reducers/db";
import freeze from "redux-freeze";
import _ from "lodash";
//import LogRocket from "logrocket";

const rootReducer = combineReducers({
  ui: uiReducer,
  db: dbReducer
});
console.log("adding logger");
//const middlewares = _.compact([thunk, freeze, LogRocket.reduxMiddleware()]);
const middlewares = _.compact([thunk, freeze]);
const createStoreWithMiddleware = applyMiddleware(...middlewares);
let composeEnhancer = compose;

composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = createStore(
  rootReducer,
  composeEnhancer(createStoreWithMiddleware)
);
console.log("created store");

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js